import BaseComponent from '../../components/base-component/base-component'

class ProductMedia extends BaseComponent {
  connectedCallback(): void {
    this.setReady()
  }

  updateFirstMediaByVariant(variant, isForceAnimation = false): void {
    if (variant && variant.featured_media) {
      const media = this.querySelector(
        `[data-media-id="${variant.featured_media.id}"]`,
      )

      if (media) {
        media.scrollIntoView({ behavior: isForceAnimation ? 'auto' : 'smooth' })
      }
    }
  }

  setReady(): void {
    this.setAttribute('ready', '')
  }
}

export default ProductMedia
